import styled from "styled-components/macro";
import { Select as MSelect, Typography } from "antd";
import { customScrollbar } from "src/utils/styledComponents/scroll";
import { theme } from "src/theme/theme";
import { colors } from "src/theme/colors";
import { line, radii, withAlpha } from "src/theme/ui";

export const SelectTheme = styled(MSelect)`
  & .ant-select-selector {
    border-radius: 5px !important;
    border: 1px solid ${theme.colors.primary[500]} !important;
    background: ${theme.colors.primary[10]};
    color: ${theme.colors.primary[500]};
    height: 40px !important;
  }
  & .ant-select-selection-item {
    display: flex;
    align-items: center;
  }
`;

/**
 * The select on the deposit, withdraw and settings forms.
 *
 * Bordered in a full accent line, like the inputs beside it were — so a form
 * of eight controls was eight accent rectangles and the accent had nothing
 * left to mean. Hairline at rest, accent on focus, and an error reddens the
 * edge rather than being the only state that changes colour.
 */
export const Select = styled(MSelect)<{ error?: string; color?: string }>`
  &.ant-select {
    &.ant-select-single.ant-select-lg:not(.ant-select-customize-input)
      .ant-select-selector {
      height: 38px;
    }
    .ant-select-selector {
      border: 1px solid
        ${({ error }) => (error ? theme.colors.error[300] : line.field)} !important;
      padding: 0 12px;
      box-shadow: none !important;
      transition: border-color 0.15s ease, box-shadow 0.15s ease;
      .ant-select-selection-item {
        display: flex;
        align-items: center;
      }
      .ant-select-selection-placeholder {
        line-height: 36px !important;
        margin-left: 0;
        color: ${colors.gray[400]};
      }
    }

    .ant-select-selection-item {
      font-size: 13px;
      color: ${colors.gray[900]};
      line-height: 36px !important;
    }

    &:hover .ant-select-selector {
      border-color: ${colors.gray[300]} !important;
    }

    &.ant-select-focused .ant-select-selector {
      border-color: ${({ error }) =>
        error ? colors.error[500] : colors.primary[500]} !important;
      box-shadow: 0 0 0 3px
        ${({ error }) =>
          withAlpha(
            error ? colors.error[500] : colors.primary[500],
            0.14,
          )} !important;
    }
  }
  &.ant-select-disabled {
    cursor: default !important;
    .ant-select-selector {
      background-color: ${colors.gray[50]} !important;
      border-color: ${line.hairline} !important;
      color: ${colors.gray[600]} !important;
      cursor: default !important;

      .ant-select-selection-search-input {
        cursor: default !important;
      }
    }
  }

  &.ant-select-single.ant-select-lg:not(.ant-select-customize-input)
    .ant-select-selector {
    padding: 0 12px;
  }

  &:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: ${radii.control}px !important;
  }

  ${customScrollbar}
`;

export const Label = styled.label`
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 600;
  color: ${colors.gray[700]};

  .ant-typography-danger {
    color: ${colors.error[600]} !important;
  }
`;

export const Text = styled(Typography.Text)`
  &.ant-typography {
    font-size: 11.5px;
    opacity: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    .ant-typography-danger {
      color: ${theme.colors.error[500]} !important;
    }
    color: ${({ type }) => (type ? undefined : colors.gray[500])};
  }
`;
